import { Link, useLocation } from "react-router";

const tabs = [
  { to: "/lanes", label: "Lanes" },
  { to: "/quotes", label: "Quotes" },
  { to: "/loads", label: "Loads" },
];

/** Section switcher shown on small screens, where the top menu is replaced by the bottom bar. */
export const FreightTabs = () => {
  const { pathname } = useLocation();
  return (
    <div className="md:hidden flex gap-2 mb-2">
      {tabs.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          className={`px-3 py-1 rounded-full text-sm border ${pathname.startsWith(t.to) ? "bg-secondary font-medium" : "text-muted-foreground"}`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
};
